import { Grid, Box, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import styles from "./styles";

const Artist = ({ image, name, stageName, id, isAdminPage = false }) => {
  const navigate = useNavigate();

  if (isAdminPage) {
    return (
      <Box sx={styles.adminContainerSx}>
        <Box
          component="img"
          src={image}
          alt={name || "Artist"}
          loading="lazy"
          sx={styles.adminImageSx}
        />
        <Box sx={styles.adminInfoBoxSx}>
          <Typography sx={styles.adminStageNameSx}>
            {stageName}
          </Typography>
          {name && (
            <Typography sx={styles.adminNameSx}>
              {name}
            </Typography>
          )}
        </Box>
      </Box>
    );
  }

  return (
    <Grid
      sx={styles.containerSx}
      onClick={() => navigate(`/artist/${id}`)}
    >
      <Box sx={styles.imageSx} component="img" src={image} alt={name || "Artist"} loading="lazy" />
      <Box sx={styles.nameContainerSx}>
        {name && (
          <Typography sx={styles.nameSx}>
            {name}
          </Typography>
        )}
        <Typography sx={styles.stageNameSx}>
          {stageName}
        </Typography>
      </Box>
    </Grid>
  );
};

export default Artist;
